/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The NotificationAlert model module.
 * @module model/NotificationAlert
 * @version 1.0.0
 */
export class NotificationAlert {
  /**
   * Constructs a new <code>NotificationAlert</code>.
   * @alias module:model/NotificationAlert
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>NotificationAlert</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NotificationAlert} obj Optional instance to populate.
   * @return {module:model/NotificationAlert} The populated <code>NotificationAlert</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new NotificationAlert();
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('emails'))
        obj.emails = ApiClient.convertToType(data['emails'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {Boolean} enabled
 */
NotificationAlert.prototype.enabled = undefined;

/**
 * @member {Array.<String>} emails
 */
NotificationAlert.prototype.emails = undefined;

